import classNames from 'classnames'
import { useMemo } from 'react'

import { getSizeMods } from '../commitment/helpers/getSizeMods'
import { TSize } from '../commitment/models'

import styles from './CommitmentStatusIcon.module.scss'

interface IProps {
  icon: string
  color: string
  size?: TSize
  className?: string
}

export const CommitmentStatusIcon = ({ icon, color, size, className }: IProps) => {
  const sizeMods = useMemo(() => getSizeMods(styles, size), [size])

  return (
    <div className={classNames(className, sizeMods)} style={{ color: color }}>
      <i className={`${icon}`} />
    </div>
  )
}
